export const ArticleUserAuditStatus = {
  UNREVIEW: 'unreview',
  REQUIRES_REVISION: 'requires_revision',
  REQUIRES_CONSULTATION: 'requires_consultation',
  REVIEWED: 'reviewed',
  REVIEW_NOT_REQUIRED: 'review_not_required',
}

export const ArticleUserAuditStatusText = {
  [ArticleUserAuditStatus.UNREVIEW]: '未レビュー',
  [ArticleUserAuditStatus.REQUIRES_REVISION]: '修正依頼',
  [ArticleUserAuditStatus.REQUIRES_CONSULTATION]: '相談依頼',
  [ArticleUserAuditStatus.REVIEWED]: 'レビュー済',
  [ArticleUserAuditStatus.REVIEW_NOT_REQUIRED]: '対応不要',
}

export const ArticleUserAuditStatusColor = {
  [ArticleUserAuditStatus.UNREVIEW]: '#DB2729',
  [ArticleUserAuditStatus.REQUIRES_REVISION]: '#FBBD09',
  [ArticleUserAuditStatus.REQUIRES_CONSULTATION]: '#9966CC',
  [ArticleUserAuditStatus.REVIEWED]: '#21BA45',
  [ArticleUserAuditStatus.REVIEW_NOT_REQUIRED]: '#767676',
}

export const ArticleAuditEvaluateStatus = {
  EXCEPTION: 'exception',
  ERROR: 'error',
  RISKY: 'risky',
  NEEDS_REVISION: 'needs_revision',
  NEEDS_RESERVATION: 'needs_reservation',
  PUBLISH_NG: 'publish_ng',
  PUBLISH_OK: 'publish_ok',
}

export const ArticleAuditEvaluateStatusText = {
  [ArticleAuditEvaluateStatus.EXCEPTION]: '対象外',
  [ArticleAuditEvaluateStatus.ERROR]: 'エラー',
  [ArticleAuditEvaluateStatus.RISKY]: 'リスクあり',
  [ArticleAuditEvaluateStatus.NEEDS_REVISION]: '要修正',
  [ArticleAuditEvaluateStatus.NEEDS_RESERVATION]: '要予約',
  [ArticleAuditEvaluateStatus.PUBLISH_NG]: '公開 NG',
  [ArticleAuditEvaluateStatus.PUBLISH_OK]: '公開 OK',
}

export const ArticleAuditEvaluateStatusColor = {
  [ArticleAuditEvaluateStatus.EXCEPTION]: '#767676',
  [ArticleAuditEvaluateStatus.ERROR]: '#FBBD09',
  [ArticleAuditEvaluateStatus.RISKY]: '#FBBD09',
  [ArticleAuditEvaluateStatus.NEEDS_REVISION]: '#FBBD09',
  [ArticleAuditEvaluateStatus.NEEDS_RESERVATION]: '#9966CC',
  [ArticleAuditEvaluateStatus.PUBLISH_NG]: '#DB2729',
  [ArticleAuditEvaluateStatus.PUBLISH_OK]: '#21BA45',
}

export const ArticleAuditRiskLevel = {
  ZERO: 'zero',
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
}
